<template>
  <vs-popup class="holamundo" :title='`کد جدید درگاه "${shopName}"`' :active.sync="popupActive">
    <div>
      ایجاد کد فعال سازی جدید باعث از بین رفتن کد قبلی می شود.
      <br />
      آیا از ایجاد کد جدید اطمینان دارید؟
      <br />
      <p v-if="apikey" class="mt-4">
        <feather-icon icon="CopyIcon" @click="copy(apikey)" />
        <span> {{ apikey }} </span>
      </p>
      <br />
      <vs-button
        v-if="apikey"
        @click="
          copy(apikey);
          popupActive = false;
        "
        class="mx-3"
        color="success"
        type="border"
        icon-pack="feather"
        >کپی و بستن</vs-button
      >
      <vs-button
        @click="generate()"
        class="mx-3"
        color="success"
        type="filled"
        icon-pack="feather"
        >دریافت کد جدید</vs-button
      >
    </div>
  </vs-popup>
</template>


<script>
export default {
  name: "generate-api-key",
  data() {
    return {
      popupActive: false,
      shopId: "",
      username: "",
      shopName: "",
      apikey: "",
      currentUser:true
    };
  },
  methods: {
    generate() {
      let loading = this.$vs.loading();
      let payload = {};
      let path = this.currentUser
        ? `/api/services/app/User/SetApiKeyMerchantAccount_CurrentUser`
        : `/api/services/app/User/SetApiKeyMerchantAccount`;
      path += `?shopId=${this.shopId}`;
      this.$http
        .post(path)
        .then(async (response) => {
          this.apikey = response.data.result;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    show(shopId,shopName,currentUser=true) {
      this.apikey = "";
      this.shopId = shopId;
      this.shopName = shopName;
      this.currentUser = currentUser;
      this.popupActive = true;
    },
    copy(str) {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      el.setSelectionRange(0, 99999);
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$vs.notify({
        time: 4000,
        color: "success",
        title: " کپی شد",
      });
    },
  },
};
</script>